import React from 'react';
import {Link} from 'react-router-dom';
import {
    Card, CardBlock, CardGroup, Button,
    ListGroup, ListGroupItem
} from 'reactstrap';

import {api, request, API_URL} from '../../actions/_request';
import ReactTable from "react-table";
import "react-table/react-table.css";


// styling
import './style.css';
import FaPaperplaneO from 'react-icons/lib/fa/paper-plane-o';
import IconOpen from 'react-icons/lib/fa/folder-open-o';

const ventas = [
	 'Computadora Outlet',
	 'Computadora',
	 'Cpu Outlet',
	 'Cpu',
	 'RM' ,
	 'soluciones diversas',
	 'Sistemas de Vigilancia',
	 'Licenciamiento de Software',
	 'Accesorios',
	 'Otros',
];


class Term extends React.Component {

	constructor(props) {

		super(props)

		this.state = {			
			data:[]
					};
	}

	componentDidMount() {


		 let self = this;
//console.log(this.props.datos);
		 api().get(this.props.datos)
        .then(function(response)
        {
            self.setState({
                data : response.data
            });        
         
        });  

		 
        
	

	}

     formateo(value) {
     var decimals =  2;
   var  separators =[',', ",", '.'];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '$' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return '$' + result;
}


	render() {	


		return (
		     <div className="view">

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Ventas Especiales</h1>
                    </header>
                </div>

                <div className="view-content view-components ">
                    <Card>
                        <CardBlock>
                        <div className="text-right">
                                
                            </div>
                            <ReactTable
                              data      = {this.state.data}
                              className = "-striped -highlight"
                              columns   = {[
                               
                                {Header: 'Empleado', accessor: 'usuario'},                              
                                {Header: 'Departamento', accessor: 'departamento'},
                                
                              
                              ]}
                              SubComponent={row => {
                                                return (
                                                    <div className='letra_chica' style={{ padding: "20px" }}>
                                                        <div>
                                                            <strong>Ventas: </strong><br/>
                                                        </div>

                                                        <table className="table">
                                                            <thead>
                                                                <tr>
                                                                  
                                                                    <th>Fecha</th>
                                                                    <th>Cliente</th>
                                                                    <th>Ticket</th>
                                                                    <th>Equipo</th>
                                                                    <th>Cant.</th>
                                                                    <th>Venta</th>
                                                                    <th>Costo</th>
                                                                    <th>Incremento</th>
                                                                    <th>Comision</th>
                                                                    <th>Com. vta.</th>
                                                                    <th>total</th>
                                                                    <th></th>
                                                                    
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {row.original.items.map((item, i) => 
                                                                    <tr key={i}>
                                                                  
                                                                    <td>{item.fecha}</td>
                                                                    <td>{item.cliente}</td>
                                                                    <td>{item.ticket}</td>
                                                                    <td>{item.producto}</td>
                                                                    <td>{item.cantidad}</td>
                                                                    <td>{this.formateo(item.precio)}</td>
                                                                    <td>{this.formateo(item.costo)}</td>
                                                                    <td>{this.formateo(item.incremento)}</td>
                                                                    <td>{parseInt(item.tipo_comision)===1?this.formateo(item.textcomision):item.textcomision}</td>
                                                                    <td>{this.formateo(item.comision)}</td>
                                                                    <td>{this.formateo(item.total)}</td>

                                                                    <td>  <Link to={`/tickets/ver/`+item.id}>
                                                    <Button color="secondary" className="btn-sm">
                                                        <IconOpen />
                                                    </Button>
                                                </Link></td>
                                                                  
                                                                </tr>)}
                                                            </tbody>
                                                        </table>
                                                       
                                                    </div>
                                                );
                                              }}
                             
                              filterable 
                              defaultPageSize={10} 

                             
                            />
                        </CardBlock>
                    </Card>
                </div>        
                 

            </div>
		)
	}

}


export default Term


// WEBPACK FOOTER //
// ./src/views/reportes/ventasEspeciales.js